// Main Components
import * as React from "react"
import { Script } from "gatsby"

const Gclid = () => {
  return (
    <Script type="text/javascript">
      {`
        function setCookie(name, value, days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          const expires = "; expires=" + date.toGMTString();
          document.cookie = name + "=" + value + expires + ";path=/";
        }

        function getParam(p) {
          const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
          return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));

        }

        const gclid = getParam('gclid');
        if (gclid) {
          const gclsrc = getParam('gclsrc');
          if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
            setCookie('gclid', gclid, 90);

            // Log gclid value for debugging
        console.log('gclid cookie set:', readCookie('gclid'));
          }

          // Set hidden input values
const hiddenInputs = document.querySelectorAll('input[type="hidden"][id="gclid"]');
hiddenInputs.forEach(input => {
  input.value = readCookie('gclid');
});

        }

        function readCookie(name) {
          const n = name + "=";
          const cookie = document.cookie.split(';');
          for (let i = 0; i < cookie.length; i++) {
            let c = cookie[i];
            while (c.charAt(0) === ' ') {
              c = c.substring(1, c.length);
            }
            if (c.indexOf(n) === 0) {
              return c.substring(n.length, c.length);
            }
          }
          return null;
        }

        // window.onload = function() {
        //   document.getElementById('gclid').value = readCookie('gclid');
        // };
      `}
    </Script>
  );
}

export default Gclid;
